import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./breadcrumb.script";
export function RuiBreadcrumb({
  children,
  label,
  separator,
  ...props
}) {
  const resolvedLabel = label || "Breadcrumb";
  const resolvedSeparator = separator || "/";
  return /* @__PURE__ */jsx("rui-breadcrumb", {
    ...props,
    label,
    separator,
    children: /* @__PURE__ */jsx("nav", {
      class: "rui-breadcrumb",
      "aria-label": resolvedLabel,
      style: {
        "--rui-breadcrumb-separator": JSON.stringify(resolvedSeparator)
      },
      children
    })
  });
}
export function RuiBreadcrumbList({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("ol", {
    ...props,
    class: cx("rui-breadcrumb__list", className),
    children
  });
}
export function RuiBreadcrumbItem({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("li", {
    ...props,
    class: cx("rui-breadcrumb__item", className),
    children
  });
}
export function RuiBreadcrumbLink({
  children,
  href,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("a", {
    ...props,
    class: cx("rui-breadcrumb__link", className),
    href,
    children
  });
}
export function RuiBreadcrumbPage({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    class: cx("rui-breadcrumb__page", className),
    "aria-current": "page",
    children
  });
}
export function RuiBreadcrumbSeparator({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("li", {
    ...props,
    class: cx("rui-breadcrumb__separator", className),
    role: "presentation",
    "aria-hidden": "true",
    children
  });
}
export function RuiBreadcrumbEllipsis({
  label = "More",
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsxs("span", {
    ...props,
    class: cx("rui-breadcrumb__ellipsis", className),
    role: "presentation",
    "aria-hidden": "true",
    children: [/* @__PURE__ */jsx("span", {
      "aria-hidden": "true",
      children: "\u2026"
    }), /* @__PURE__ */jsx("span", {
      class: "rui-breadcrumb__ellipsis-label",
      children: label
    })]
  });
}